import script from "./start.vue?vue&type=script&setup=true&lang=js"
export * from "./start.vue?vue&type=script&setup=true&lang=js"

import "./start.vue?vue&type=style&index=0&id=39fc0776&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39fc0776"]])

export default __exports__